import { motion } from 'framer-motion';
import { PropsWithChildren } from 'react';

import { opacityVariants } from './framer-variants';

export const OpacityAnimation = (props: PropsWithChildren) => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={opacityVariants}
      style={{ width: '100%' }}
    >
      {props.children}
    </motion.div>
  );
};
